export default __webpack_public_path__ + "static/media/appleStore.c8aa6b6a.svg";